<div data-testid="detail-container" class="reservation-detail-container">
  <!-- Loading State -->
  @if (isLoading()) {
  <div data-testid="detail-loading" class="loading-container">
    <p>{{ "reserved_inventory_management.detail.messages.loading" | translate }}</p>
  </div>
  }

  <!-- Reservation Details Form -->
  @if (reservationDetail() && !isLoading()) {
  <app-add-form
    data-testid="detail-form"
    [title]="'reserved_inventory_management.detail.view_title'"
    [viewMode]="true"
    [formFields]="formFields()"
    [initialData]="formData()"
    [headerActions]="headerActions()"
    (headerAction)="onHeaderAction($event)"
  ></app-add-form>
  }
</div>
